import authFetch from '../utils/authFetch';

/**
 * JSON request to the Website Management admin API (backend
 * routes/website_catalog.js). Throws an Error carrying the server's Hebrew
 * message, so callers can show it as-is with notify().
 */
export async function websiteRequest(path, method = 'GET', body) {
  const res = await authFetch(path, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : undefined,
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || 'שגיאה בשמירה');
  return data;
}

/** Same list convention the other custom pickers use (_start/_end + filter). */
export const listUrl = (resource, filter = {}, end = 1000, sort = 'id') =>
  `/${resource}?_start=0&_end=${end}&_sort=${sort}&_order=ASC&filter=${encodeURIComponent(JSON.stringify(filter))}`;

// Per family (mirrors WEBSITE_FAMILY_RULES in backend/constants/statuses.js):
// the customer's choices, in table-column order, and whether the listing has
// one fixed script + size instead of a size choice.
export const FAMILY_SELECTION_KEYS = {
  simple_tefillin: ['hand', 'type'],
  gasot_tefillin:  ['size', 'hiddur', 'hand', 'type'],
  mezuzah:         ['hiddur'],
  megillah:        ['hiddur'],
};
export const hasFixedSize = family => ['simple_tefillin', 'mezuzah', 'megillah'].includes(family);
// Mezuzah and Megillah: one fixed script + size per listing, Hiddur chosen.
export const isHiddurOnly = family => family === 'mezuzah' || family === 'megillah';
// The CRM attribute holding the family's size (mirrors FAMILY_CRM_SIZE_KEY in the backend).
export const crmSizeKey = family => (family === 'megillah' ? 'CM' : 'size');
export const hasScript = family => family in FAMILY_SELECTION_KEYS;
// An image per Hiddur level (mirrors HIDDUR_IMAGE_FAMILIES in the backend).
export const hasHiddurImages = family => FAMILY_SELECTION_KEYS[family]?.includes('hiddur') ?? false;

/** Website prices are integer minor units (cents, USD). */
export const minorToInput = minor => (minor === undefined || minor === null ? '' : (minor / 100).toFixed(2));
export const inputToMinor = value => {
  const s = String(value ?? '').trim();
  if (!/^\d+(\.\d{1,2})?$/.test(s)) return null;
  const minor = Math.round(Number(s) * 100);
  return minor > 0 ? minor : null;
};
export const fmtUsd = minor =>
  minor === undefined || minor === null ? '—' : `$${(minor / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

/** Canonical key of a selections object (order-independent). */
export const selectionKey = sel =>
  JSON.stringify(Object.keys(sel).sort().map(k => [k, sel[k]]));
